import * as React from 'react';
const AsteniaSessualeIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <circle cx={106.46} cy={72.2} r={16.25} className="prefix__cls-2" />
    <path
      d="m77.3 101.36 17.67-17.68M77.3 88.99l12.37 12.37"
      className="prefix__cls-2"
    />
    <circle cx={92.5} cy={127.8} r={16.25} className="prefix__cls-1" />
    <path
      d="m123.74 96.56-19.75 19.76M111.25 96.56h12.49v12.5"
      className="prefix__cls-1"
    />
  </svg>
);
export default AsteniaSessualeIcon;
